import { render, staticRenderFns } from "./divide-accounts.vue?vue&type=template&id=3dda0ef4&scoped=true&"
import script from "./divide-accounts.vue?vue&type=script&lang=js&"
export * from "./divide-accounts.vue?vue&type=script&lang=js&"
import style0 from "./divide-accounts.vue?vue&type=style&index=0&id=3dda0ef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dda0ef4",
  null
  
)

export default component.exports